const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

// Statsig's Events
export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_TICKET_SELECTION_VIEW:
        'Listing - Conversion Bar - Ticket Selection - View',
    LISTING_ALL_EVENT_DETAILS_VIEW:
        'Listing - All - Click - View All Event Details',
    LISTING_TICKET_SELECTION_CLICK:
        'Listing - Conversion Bar - Ticket Selection - Click',
    CHILD_EVENTS_DROPDOWN:
        'Listing - Select a date - Change - Child Events Dropdown',
    MORE_OPTIONS_BUTTON:
        'Listing - Select a date - Click - More Options Button',
    MORE_OPTIONS_CARD: 'Listing - Select a date - Click - More Options Card',
    CAROUSEL_CARD: 'Listing - Select a date - Click - Carousel card',
    LISTING_MORE_ORGANIZER_EVENT_CLICK:
        'Listing - All - Click - More Organizer Event',
    LISTING_MORE_ORGANIZER_EVENT_LIKE:
        'Listing - All - Click - More Organizer Event Like',
    LISTING_MORE_ORGANIZER_EVENT_SHARE:
        'Listing - All - Click - More Organizer Event Share',
    LISTING_RELATED_EVENT_CLICK: 'Listing - All - Click - Related Event',
    LISTING_RELATED_EVENT_LIKE: 'Listing - All - Click - Related Event Like',
    LISTING_RELATED_EVENT_SHARE: 'Listing - All - Click - Related Event Share',
    LISTING_AD_BANNER_CLICK: 'Listing - All - Click - Ad Banner CTA',
    LISTING_NIGHTLIFE_BANNER_CLICK:
        'Listing - All - Click - Nightlife Banner CTA',
    LISTING_NYE_TOUCHPOINT_CLICK: 'Listing - All - Click - NYE Touchpoint CTA',
    LISTING_SUBCATEGORY_CTA_CLICK:
        'Listing - Expired Event Page - Click - Category Browse Modal CTA',
    LISTING_FOLLOW_CLICK: 'Listing - All - Click - Follow',
    LISTING_UNFOLLOW_CLICK: 'Listing - All - Click - Unfollow',
};

// Statsig's Multi Tickets Experiment
export const MULTI_TICKETS_ON_LISTINGS_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'multi_ticket_selection',
};

//Statsig's Avoid recharge dates on all events
export const LISTING_AVOID_RECHARGE_DATES_ON_ALL_EVENTS = {
    experimentName: 'listing_avoid_recharge_dates_on_all_events',
    param: 'avoid_recharge_event_dates',
    defaultValue: false,
};

//Statsig's Seasonal Ad Banner Visibility
export const LISTING_SEASONAL_AD_BANNER = {
    experimentName: 'halloween_promotion_on_listing_page',
    param: 'show_seasonal_ad_banner',
    defaultValue: false,
};

//Statsig's Subcategory Browse Modal Visibility on Expired/Past Events Page
export const LISTING_SUBCATEGORY_BROWSE = {
    experimentName: 'listings_subcategory_browse',
    param: 'show_subcategory_browse_modal',
    defaultValue: 'hide',
};

//Statsig's NYE/Nightlife Touchpoint Visibility
export const LISTING_NIGHTLIFE_NYE_TOUCHPOINT = {
    experimentName: 'nye_nightlife_touchpoint_on_listing_page',
    param: 'show_nye_nightlife_touchpoint',
    defaultValue: 'hide',
};

//Statsig's create quality trust signal
export const LISTING_CREATE_QUALITY_SIGNAL = {
    experimentName: 'creator_quality_trust_signal_listing_page_phase3',
    param: 'show_variant_type',
    defaultValue: 'control',
};

//Statsig's showing default profile picture
export const LISTING_DEFAULT_PROFILE_PICTURE = {
    experimentName: 'creator_quality_profile_picture_listing_page',
    param: 'show_variant_type',
    defaultValue: 'control',
};

// Statsig's First Hierarchy Level Experiment for Listings Team
export const LISTING_FIRST_HIERARCHY_LEVEL_EXPERIMENT = {
    experimentName: 'listing_first_hierarchy_level',
    param: 'show_first_hierarchy_level',
    defaultValue: false,
};

// Statsig's First Hierarchy Level Experiment for Listings Team
export const LISTING_SECOND_HIERARCHY_LEVEL_EXPERIMENT = {
    experimentName: 'listing_second_hierarchy_level',
    param: 'show_second_hierarchy_level',
    defaultValue: false,
};

// Statsig's First Hierarchy Level Experiment for Listings Team
export const LISTING_THIRD_HIERARCHY_LEVEL_EXPERIMENT = {
    experimentName: 'listing_third_hierarchy_level',
    param: 'show_third_hierarchy_level',
    defaultValue: false,
};

/**
 * As part of improving consumer’s effort to ensuring experimentation data
 * consistency between Statsig and Heap, Browse & Explore will run a series
 * of A/A tests to validate what the discrepancy looks like today.
 */
export const AA_STABLE_ID_TEST = {
    experimentName: 'aa_stableid_test',
    param: 'variant_type',
    defaultValue: 'control',
};

export const AA_SESSION_ID_TEST = {
    experimentName: 'aa_sessionid_test',
    param: 'variant_type',
    defaultValue: 'control',
};

export const AA_USER_ID_TEST = {
    experimentName: 'aa_userid_test',
    param: 'variant_type',
    defaultValue: 'control',
};
